import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";

interface ProgressBarProps {
  progress: number;
}

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <Container className="ig-dp-inactive-bar">
      <Progress progress={progress}>&nbsp;</Progress>
    </Container>
  );
};

const Container = styled("div")(() => {
  const { device } = useProgressBarContext();
  const { thickness, inactiveColor } = device.widget.styles.bar;
  return {
    width: "100%",
    height: thickness,
    background: inactiveColor,
    display: "flex",
    justifyContent: "start",
    borderRadius: thickness / 2,
    position: "absolute",
  };
});

const Progress = styled("div")(({ progress }: ProgressBarProps) => {
  const { device } = useProgressBarContext();
  const { thickness, activeColor } = device.widget.styles.bar;
  return {
    height: thickness,
    background: activeColor,
    borderRadius: thickness / 2,
    transition: "width 1s",
    position: "absolute",
    display: "block",
    width: `${progress}%`,
  };
});
